import { render } from "./scroller.vue?vue&type=template&id=7152965f"
import script from "./scroller.vue?vue&type=script&lang=js"
export * from "./scroller.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__